import type { FC } from 'react';
import type { Theme } from '@mui/material';
import { styled } from '@mui/material';
import type { SxProps } from '@mui/system';
import logImg from '@/assets/logo_transparent.png'

interface LogoProps {
  sx?: SxProps<Theme>;
}

const LogoRoot = styled('img')();

const Logo: FC<LogoProps> = (props) => (
  <LogoRoot
    src={logImg}
    alt="OnData logo"
    height="45"
    {...props}
  >    
  </LogoRoot>
);

export default Logo;
